import { ResourcePermissions } from '../interfaces/current-supplier-user.interface';
import { AccessTypeEnum } from '../interfaces/permissions.interface';
import { PERMISSIONS_HIERARCHY } from '../constants/general-constants';

export function supplierUserHasResourcePermission(
    supplierUserResourcePermissions: ResourcePermissions[] | undefined,
    resourceIdToCheck: string,
    minLevel: AccessTypeEnum,
): boolean {
    if (!supplierUserResourcePermissions || !supplierUserResourcePermissions.length) {
        return false;
    }

    const supplierUserAccess = supplierUserResourcePermissions?.find(
        (x) => x?.resourceId?.toLowerCase() === resourceIdToCheck.toLocaleLowerCase(),
    );
    if (!supplierUserAccess || !supplierUserAccess.accessType) {
        return false;
    }

    const permissionHierarchyToCompare = PERMISSIONS_HIERARCHY.map((x) => x.toLowerCase());
    const supplierUserLevelToCompare = supplierUserAccess.accessType.toLocaleLowerCase();
    const minLevelToCompare = minLevel.toLocaleLowerCase();
    return permissionHierarchyToCompare.indexOf(minLevelToCompare) <= permissionHierarchyToCompare.indexOf(supplierUserLevelToCompare);
}
